require("jquery");
require('./js/main.js');
require("bootstrap-sass");
require('./sass/index.scss');